import { useState } from "react";
import { CustomInputTextArea } from "../../common/formControls";
import {
  TEMPLATE_TEXT_MAX_LENGTH,
  exceedsTemplateTextLimit,
  templateTextLimitMessage,
} from "./templateTextLimits";

const SIGNATURE_LABEL = "Signature text";

const ConfirmSignature = ({ setPostData, postData, isError = false, errorMessage = "" }) => {
  const [limitError, setLimitError] = useState("");
  const clause = postData?.leaseApplicationTemplateSections?.Signature?.clause ?? "";
  const resolvedError = limitError || (isError ? errorMessage || `${SIGNATURE_LABEL} is required` : undefined);

  return (
    <>
      <div className="edit-card p-3" id="signatureEditCard">
        <CustomInputTextArea
            name="signature"
              label="Add Signature Text"
              placeholder="Enter Signature Text"
              required={true}
              isFormControl
              value={clause}
              onChange={(e) => {
                // Do not pass maxLength into CustomInputTextArea: its built-in limit flash
                // disappears after 1s (QA reported "no validation"). Mirror FeeTemplete —
                // reject over-long input here and keep a persistent inline message.
                if (exceedsTemplateTextLimit(e.target.value)) {
                  setLimitError(templateTextLimitMessage(SIGNATURE_LABEL));
                  return;
                }
                setLimitError("");
                setPostData({
                  ...postData,
                  leaseApplicationTemplateSections: {
                    ...postData.leaseApplicationTemplateSections,
                    Signature: {
                      ...(postData.leaseApplicationTemplateSections?.Signature ?? {}),
                      clause: e.target.value,
                    },
                  },
                });
              }}
              rows={3}
              isError={isError || !!limitError}
              errorMessages={resolvedError}
              myClassName="normal_text "
              width="343px"
        />
        <div className="d-flex justify-content-end mb-2" style={{ width: "343px" }}>
          <span className="sub_text grey_subtext1" style={{ fontSize: "11px", marginTop: "4px" }}>
            {String(clause).length}/{TEMPLATE_TEXT_MAX_LENGTH}
          </span>
        </div>
      </div>
    </>
  );
};

export default ConfirmSignature;
